import React from "react";
import Marquee from "react-fast-marquee";
import { useLang } from "../../lib/i18n";

export const BrandMarquee = () => {
  const { t } = useLang();
  return (
    <section className="relative z-10 border-y border-white/10 bg-charcoal py-8 md:py-10" data-testid="marquee">
      <Marquee speed={35} gradient={false} autoFill>
        {t.marquee.map((word, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display font-bold text-4xl md:text-6xl text-stroke px-8 tracking-tight">
              {word}
            </span>
            <span className="text-emerald2 text-3xl px-2">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
};
